import InputView from './input-phone-view'

export default InputView
